<template>
  <v-container>
    <v-row>
      <v-col cols="5" class="call-tabs">
        <h5 class="text-h5">Transcription Text</h5>
        <p class="text-body-1 mt-5" v-html="transcriptionText"></p>
      </v-col>
      <v-col cols="7" class="call-tabs">
        <v-data-table
          :headers="headers"
          :items="records"
          @click:row="changeLink"
        />
      </v-col>
    </v-row>
    <v-row class="mt-5" justify="center">
      <audio ref="record" controls>
        <source :src="recordUrl" />
      </audio>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import SortService from "@/services/sort.service";

export default {
  name: "CallHistory",
  data() {
    return {
      headers: [
        {
          text: "Date",
          align: "center",
          value: "createdAt",
        },
        {
          text: "Agent",
          align: "center",
          value: "agentName",
        },
      ],
      recordUrl: "",
      transcriptionText: "Empty",
    };
  },
  methods: {
    ...mapActions({
      showHandlerSnackbar: "snackbar/showHandlerSnackbar",
    }),
    changeLink(e) {
      this.$axios
        .get(`/records/${e.id}`)
        .then((res) => {
          this.showHandlerSnackbar({
            color: res.data.status,
            text: res.data.message,
            show: true,
          });

          let transcriptionText = res.data.record.text;

          if(transcriptionText != null){
            transcriptionText = SortService.replaceAll(
              transcriptionText,
              "Speaker 1",
              "<b>Agent</b>"
            );
  
            transcriptionText = SortService.replaceAll(
              transcriptionText,
              "Speaker 2",
              "<b>Client</b>"
            );

            this.transcriptionText = transcriptionText;
          }

          this.recordUrl = res.data.record.url;
          this.$refs.record.load();
        })
        .catch((e) => {
          console.log(e);
          // this.showHandlerSnackbar({
          //   color: e.response.data.status,
          //   text: e.response.data.message,
          //   show: true,
          // });
        });
    },
  },
  computed: {
    ...mapGetters({
      records: "records/records",
    }),
  },
};
</script>

<style lang="scss">
.call-tabs {
  max-height: 400px;
  overflow: auto;
}
</style>
